/**
 * Окно «Новый пользователь»: особое поведение для роли «Кассир» (AUFB-90).
 *
 * Кассир работает только на терминале и входит цифровыми логином и паролем. Поэтому при
 * отметке роли «Кассир» снимаем «Доступ в CRM» и, если логин или пароль пустые, просим бэкенд
 * сгенерировать их (только он знает, какие логины заняты).
 */

export const CASHIER_ROLE = "cashier";

function cashierRoleId(roles) {
  return roles.find((r) => r.name === CASHIER_ROLE)?.id ?? null;
}

export function hasCashierRole(roleIds, roles) {
  const id = cashierRoleId(roles);
  return id !== null && roleIds.includes(id);
}

/**
 * Новые роли формы. Если «Кассир» только что отмечен — снимаем «Доступ в CRM» и сообщаем,
 * нужны ли сгенерированные логин/пароль. При снятии «Кассира» доступ в CRM сам не включается.
 */
export function applyRoleChange(form, nextRoleIds, roles) {
  const cashierAdded = hasCashierRole(nextRoleIds, roles) && !hasCashierRole(form.roles, roles);
  const next = { ...form, roles: nextRoleIds };
  if (!cashierAdded) return { form: next, needsCredentials: false };
  next.is_staff = false;
  return { form: next, needsCredentials: !form.username.trim() || !form.password };
}

/** Подставляет сгенерированное только в пустые поля — введённое вручную не трогаем. */
export function fillEmptyCredentials(form, credentials) {
  return {
    ...form,
    username: form.username.trim() ? form.username : credentials.username,
    password: form.password ? form.password : credentials.password,
  };
}
